<template>
  <v-col class="mt-2">
    <v-row>
      <v-list dense>
        <v-list-item
          :disabled="eleCurr == null || !templateAccess"
          ripple
        >
          <v-list-item-avatar @click="toggleMove()">
            <v-icon>mdi-cursor-move</v-icon>
          </v-list-item-avatar>
          <v-list-item-content @click="toggleMove()">
            <v-list-item-title>{{ $t("template.movable") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              v-model="eleMove"
              inset
              :disabled="eleCurr == null || !templateAccess"
              @change="moveChanged()"
            />
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          :disabled="eleCurr == null || !templateAccess"
          ripple
        >
          <v-list-item-avatar @click="toggleEdit()">
            <v-icon>mdi-pencil</v-icon>
          </v-list-item-avatar>
          <v-list-item-content @click="toggleEdit()">
            <v-list-item-title>{{ $t("template.editable") }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-switch
              v-model="eleEdit"
              inset
              :disabled="eleCurr == null || !templateAccess"
              @change="editChanged()"
            />
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    elementCurrent: {
      type: Object,
      default: () => {},
    },
    templateAccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eleCurr: null,
      eleEdit: true,
      eleMove: true,
    };
  },
  watch: {
    elementCurrent: {
      immediate: true,
      handler(val) {
        this.eleCurr = val;

        if (this.eleCurr != null) {
          this.eleEdit = true;
          this.eleMove = true;

          if (this.eleCurr.konvaObjectOption !== undefined) {
            if (this.eleCurr.konvaObjectOption.editable !== undefined) {
              this.eleEdit = this.eleCurr.konvaObjectOption.editable;
            }
          }

          if (this.eleCurr.konvaObjectOption !== undefined) {
            if (this.eleCurr.konvaObjectOption.movable !== undefined) {
              this.eleMove = this.eleCurr.konvaObjectOption.movable;
            }
          }
        }
      },
    },
  },
  created() {
    //
  },
  methods: {
    editChanged() {
      this.$emit("edit-changed", this.eleEdit);
    },
    moveChanged() {
      this.$emit("move-changed", this.eleMove);
    },
    toggleEdit() {
      this.eleEdit = !this.eleEdit;
      this.editChanged();
    },
    toggleMove() {
      this.eleMove = !this.eleMove;
      this.moveChanged();
    },
  },
};
</script>
